import { render, staticRenderFns } from "./WateroDetails.vue?vue&type=template&id=ca0d18ba&scoped=true"
import script from "./WateroDetails.vue?vue&type=script&lang=js"
export * from "./WateroDetails.vue?vue&type=script&lang=js"
import style0 from "./WateroDetails.vue?vue&type=style&index=0&id=ca0d18ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0d18ba",
  null
  
)

export default component.exports